import React, {createContext, useContext, useState} from "react";
import {useInterval} from "./interval.hook";
import {NotificatorContext} from "../Notificator";

export const ResetContext = createContext()

export const ResetProvider = ({children}) => {

    const [timeLeft, setTimeLeft] = useState(1800)
    const [visible, setVisible] = useState(false)
    const {showNotification} = useContext(NotificatorContext)

    const interval = () => {
        setTimeLeft(prev => {
            if (prev === 0) {
                stopTimer()
                showNotification('Data has been reset to initial state. Please, refresh')
                return 1800
            } else {
                return prev - 1
            }
        })
    }

    useInterval(interval, visible ? 1000 : null)

    const initTimer = (initValue) => {
        if(initValue) {
            setTimeLeft(initValue)
        }
        setVisible(true)
    }

    const stopTimer = () => {
        setVisible(false)
    }



    return (
        <ResetContext.Provider value={{
            initTimer,
            stopTimer,
            timeLeft,
            visible
        }}>
            {children}
        </ResetContext.Provider>
    )

}